import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  connect() {
    // Prevent context menu (right-click/long-press menu)
    this.handleContextMenu = this.handleContextMenu.bind(this)
    this.element.addEventListener('contextmenu', this.handleContextMenu, true)
    
    // Prevent text selection start event
    this.handleSelectStart = this.handleSelectStart.bind(this)
    this.element.addEventListener('selectstart', this.handleSelectStart, true)
    
    // Simple long-press prevention for links
    this.handleTouchStart = this.handleTouchStart.bind(this)
    this.element.addEventListener('touchstart', this.handleTouchStart, { passive: false })
    
    // Set draggable to false on links and images (one-time setup for static content)
    this.element.querySelectorAll('a, img').forEach(el => {
      el.draggable = false
    })
  }

  handleContextMenu(event) {
    event.preventDefault()
    return false
  }

  handleSelectStart(event) {
    event.preventDefault()
    return false
  }
  
  handleTouchStart(event) {
    // Only prevent long-press on links
    const link = event.target.closest('a')
    if (!link) return
    
    // Clear any existing timer
    if (this.longPressTimer) {
      clearTimeout(this.longPressTimer)
    }
    
    // Set a new timer
    this.longPressTimer = setTimeout(() => {
      event.preventDefault()
      event.stopPropagation()
    }, 500)
    
    // Clear timer on touchend or touchmove
    const clearTimer = () => {
      if (this.longPressTimer) {
        clearTimeout(this.longPressTimer)
        this.longPressTimer = null
      }
      // Remove these listeners after they fire once
      this.element.removeEventListener('touchend', clearTimer)
      this.element.removeEventListener('touchmove', clearTimer)
    }
    
    this.element.addEventListener('touchend', clearTimer, { once: true })
    this.element.addEventListener('touchmove', clearTimer, { once: true })
  }

  disconnect() {
    // Clean up event listeners
    this.element.removeEventListener('contextmenu', this.handleContextMenu, true)
    this.element.removeEventListener('selectstart', this.handleSelectStart, true)
    this.element.removeEventListener('touchstart', this.handleTouchStart)
    
    // Clear any pending timer
    if (this.longPressTimer) {
      clearTimeout(this.longPressTimer)
    }
  }
}